import React from 'react';
import { useSelector } from 'react-redux';
import {
  getProductTypes,
  getHasAK529Only,
} from 'src/redux/modules/productTypes/productType.selectors';
import { BRANDING_CONTACT_NUMBERS } from '../../settings/settings';

import Phone from '../../components/Shared/Phone/Phone';

export const get529PhoneBranding = (selectedProductTypes) => {
  const { hasAK529, hasMD529, hasNAT529 } = selectedProductTypes;

  if (hasAK529 && !(hasMD529 || hasNAT529)) {
    return BRANDING_CONTACT_NUMBERS.ALASKA_529;
  }
  if (hasMD529 && !(hasNAT529 || hasAK529)) {
    return BRANDING_CONTACT_NUMBERS.MARYLAND_529;
  }
  if (hasNAT529 && !(hasMD529 || hasAK529)) {
    return BRANDING_CONTACT_NUMBERS.NATIONAL_529;
  }

  return '';
};

export const has529Phone = (selectedProductTypes) => {
  const { hasAK529, hasMD529, hasNAT529 } = selectedProductTypes;
  return (
    (hasAK529 && !(hasMD529 || hasNAT529)) ||
    (hasMD529 && !(hasNAT529 || hasAK529)) ||
    (hasNAT529 && !(hasMD529 || hasAK529))
  );
};

const PhoneNumberBranding = () => {
  const selectedProductTypes = useSelector(getProductTypes);
  const hasAK529Only = useSelector(getHasAK529Only);

  return (
    <>
      {has529Phone(selectedProductTypes) ? (
        <span data-testid="branding">
          contact{' '}
          {hasAK529Only
            ? 'an education savings specialist'
            : 'a college savings specialist'}{' '}
          at <Phone phoneNumber={get529PhoneBranding(selectedProductTypes)} />
        </span>
      ) : (
        <a
          data-testid="branding-link"
          href="https://www.troweprice.com/personal-investing/help/contact/index.html"
          rel="noreferrer"
          target="_blank"
        >
          {' '}
          contact a college savings specialist
        </a>
      )}
    </>
  );
};

export default PhoneNumberBranding;
